import Modal from 'services/modal';
import BaseService from 'services/base';

const PaymentService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},
    //审核
    auditReceiptOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          status: 2,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认审核付款单？', ok, dispatch);
    },

    //审核不通过付款单(退回)
    returnReceiptOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = async (reason?) => {
        let config = {
          ...postbody,
          returnReason: reason,
          status: 4,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认退回', ok, '退回', 'showReject', '', dispatch);
    },
    //确认付款申请
    confirmPaymentApply(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您是否确认此操作？', ok, dispatch);
    },
    //发布预申请
    publishAdvPayment(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布？', ok, dispatch);
    },
    //确认预付款
    confirmAdvPayment(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您是否确认此操作?', ok, dispatch);
    }
  },
  BaseService
);

export default PaymentService;
